import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Escandallo/imprimirEscandallo`, method: 'POST', body: list, token: token})
}